import React, { useState } from 'react';

import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

import { AccountForm } from './components';
import { getUserAttributes, useUpdateUserAttributes } from '../../../../../../../../utils/use-user';
import SnackProgress from '../../../../../../../shared/snack-progress';

const Account = ({ open , onCancel }) => {
  const [progress, setProgress] = useState(null);
  const [triggerFetch, setTriggerFetch] = useState(false);
  const attributes = getUserAttributes(triggerFetch);
  const updateUser = useUpdateUserAttributes();
  const handleSubmit = async (values) => {

    try{
      setProgress({
        text: 'Updating account...',
        severity: 'info'
      });
      await updateUser(values);
      setTriggerFetch(prev => !prev)
      setProgress({
        text: 'Account updated!',
        severity: 'success'
      });
      setTimeout(() => {
        onCancel();
        setProgress(null);
      }, 2000);
    } catch(e){
      console.log(e);
      setProgress({
        text: 'Error on updating account',
        severity: 'error'
      });
      onCancel();
      setTimeout(() => setProgress(null), 2000);
    }
  }
  return(
    <Dialog open={open} onClose={onCancel} fullWidth onEntered={e => e.click(e)}>
      <DialogTitle>Account</DialogTitle>
			<DialogContent dividers>
        <AccountForm
          id="update-account"
          onSubmit={handleSubmit}
          initialValues={attributes}
        />
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          width={136}
          onClick={onCancel}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          width={136}
          type="submit"
          form="update-account"
        >
          Update
        </Button>
      </DialogActions>
      <If condition={progress}>
        <SnackProgress progress={progress} />
      </If> 
    </Dialog>
  )

}

export default Account;